<template>
    <div v-loading="loading" class="billManage">
        <div class="cur-filter-bar" ref="tableSelect">
            <!-- 筛选项行 -->
            <div class="cur-filter-row">
                <div class="cur-filter-item">
                    <label>日期</label>
                    <el-date-picker
                        style="width:140px;"
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </div>
                <div class="cur-filter-item">
                    <label>地区</label>
                    <el-select v-model="formInline.region" clearable style="width:100px" @change="search" placeholder="请选择">
                        <el-option v-for="(item,index) in regionList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-item" v-if="curRole!='customer'">
                    <label>Payers</label>
                    <el-select v-model="formInline.payer_id" clearable filterable style="width:120px" @change="onPayerChange" placeholder="请选择">
                        <el-option v-for="(item,index) in filteredPayersList" :key="index" :label="item.name+'('+item.payer_id+')'" :value="item.payer_id"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-item" v-if="curRole=='admin'">
                    <label>销售</label>
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:100px">
                        <el-option v-for="item in salesList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-item" v-if="curRole=='admin'||curRole=='sales'">
                    <label>合作伙伴</label>
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="onAgentChange" style="width:110px">
                        <el-option v-for="item in agentsList" :key="item.agent_id" :label="item.company" :value="item.agent_id"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-item">
                    <label>账单类型</label>
                    <el-select filterable v-model.trim="formInline.billType" placeholder="请选择" @change="search" style="width:110px">
                        <el-option v-for="item in billTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-item">
                    <label>账号类型</label>
                    <el-select v-model="formInline.account_type" clearable style="width:130px" @change="search" placeholder="全部">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="Normal" value="normal"></el-option>
                        <el-option label="Billing Transfer" value="bt"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-item">
                    <label>LinkId</label>
                    <el-select v-model="formInline.link_id" clearable filterable style="width:150px" @change="search" placeholder="请选择"
                      :filter-method="linkFilterMethod">
                        <el-option v-for="item in displayedLinksList" :key="item.link_id"
                          :label="(item.customer_name || item.name || item.link_id) + '（' + item.link_id + '）'"
                          :value="item.link_id"></el-option>
                    </el-select>
                </div>
                <div class="cur-filter-actions">
                    <el-button @click="search" class="btn-search" icon="Search">查询</el-button>
                    <el-button @click="reset" class="btn-reset" icon="Refresh">重置</el-button>
                </div>
            </div>
            <div class="cur-action-row">
                <span class="action-link" @click="selected.length>0?downloadTheBillByUrl(1):downloadTheBillByUrl(2)">
                    <el-icon><Download /></el-icon> 下载账单
                </span>
                <span class="action-link" @click="selected.length>0?downloadRightBill(1):downloadRightBill(2)">
                    <el-icon><Download /></el-icon> 下载对账单
                </span>
                <span class="action-link warning" v-if="curRole!='customer'" :class="{disabled: !canConfirm}" @click="canConfirm&&confirmBill()">
                    <el-icon><FolderAdd /></el-icon> 确认账单
                </span>
                <span class="action-link" @click="historyVisible=true">
                    <el-icon><Clock /></el-icon> 批量下载历史账单
                </span>
            </div>
        </div>
        <div class="table-card" ref="tableCard">
        <div class="table">
            <el-table stripe :data="tableData" ref="tableref" v-loading="loadingPage" @selection-change="selectionChange" style="width: 100%" :height="tableMaxHeight">
                <!-- <el-table-column
                    :selectable="isRowSelectable"
                    type="selection"
                    width="30"> -->
                <el-table-column
                    type="selection"
                    width="30">
                </el-table-column>
                <el-table-column label="状态" width="50" align="center">
                    <template #default="scope">
                        <el-tooltip :content="getStatusText(scope.row.locked)" placement="right" effect="customized">
                            <span class="status-dot-cell" :class="getStatusClass(scope.row.locked)"></span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="LinkerId" width="117">
                    <template #default="scope">
                        <span v-if="curRole=='customer'" class="linker-id-text">{{ scope.row.linkId }}</span>
                        <span v-else class="linker-id-link" @click="downloadTheBillByUrl(1,scope.row.linkId)">{{ scope.row.linkId }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="客户名称" width="120">
                    <template #default="scope">
                        <div style="display:flex;align-items: center;">
                            <span style="width:140px;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" :title="scope.row.company">{{scope.row.company}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Payer Name" min-width="117" show-overflow-tooltip>
                    <template #default="scope">
                         <span v-if="scope.row.payerId">{{payersMap.get(scope.row.payerId)?.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类别" width="75">
                    <template #default="scope">
                        {{ scope.row.entity }}
                    </template>
                </el-table-column>
                <el-table-column label="账单年月" width="80">
                    <template #default="scope">
                        {{scope.row.month.toString().substring(0,4)+'-'+scope.row.month.toString().substring(4,6)}}
                    </template>
                </el-table-column>
                <el-table-column label="Charge" min-width="85" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.charge) - Number(b.charge)">
                    <template #default="scope">
                        {{Number(scope.row.charge).toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="!(curRole=='customer'&&!showCredit)" label="Credit" min-width="80" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.credit) - Number(b.credit)">
                    <template #default="scope">
                        {{ Number(scope.row.credit).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="Discount" min-width="95" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.discount_distributor) - Number(b.discount_distributor)">
                    <template #default="scope">
                        <span :class="{'text-red': Number(scope.row.discount_distributor) < 0}">{{ Number(scope.row.discount_distributor).toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Tax" min-width="72" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.tax) - Number(b.tax)">
                    <template #default="scope">
                        {{ Number(scope.row.tax).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="!(curRole=='customer'&&!showSavingPlan)"  label="SavingPlans" min-width="110" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.spNegation) - Number(b.spNegation)">
                    <template #default="scope">
                        {{Number(scope.row.spNegation).toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="!(curRole=='customer'&&!showBundle)"  label="Bundle" min-width="80" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.bundledDiscount) - Number(b.bundledDiscount)">
                    <template #default="scope">
                        {{ Number(scope.row.bundledDiscount).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="TOTAL" min-width="85" align="center" sortable :sort-orders="['descending','ascending']" :sort-method="(a,b) => Number(a.costTotal) - Number(b.costTotal)">
                    <template #default="scope">
                        {{ Number(scope.row.costTotal).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="80" align="center" v-if="curRole!='customer'">
                    <template #default="scope">
                        <div class="op-icons" v-if="(this.curRole=='sales'||this.curRole=='admin')&&(scope.row.locked==0 || scope.row.locked==null|| scope.row.locked==3)">
                            <button class="op-icon-btn" @click="reDownload(scope.row.payerId,scope.row.linkId)" :disabled="canDownload" title="重新同步">
                                <el-icon><RefreshRight /></el-icon>
                            </button>
                            <button class="op-icon-btn" @click="addService(scope.row)" title="添加增值服务">
                                <el-icon><Plus /></el-icon>
                            </button>
                        </div>
                        <div class="op-icons" v-if="curRole=='agent'&&scope.row.locked==1">
                            <button class="op-icon-btn danger" @click="refuseBill(scope.row.id)" title="拒绝账单">
                                <el-icon><CircleCloseFilled /></el-icon>
                            </button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-wrapper">
            <span class="pagination-total">共 {{ pageparm.total || 0 }} 条</span>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        </div>
        <el-dialog width="40%" class="service-dialog" v-model="serviceVisible" :close-on-click-modal="false" title="VAP增值服务">
            <el-table stripe :data="serviceData" style="width: 100%">
                <el-table-column label="服务描述">
                    <template #default="scope">
                        {{ scope.row.serviceName }}
                    </template>
                </el-table-column>
                <el-table-column label="税前金额" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.cost).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="税点" align="right">
                    <template #default="scope">
                        {{ (Number(scope.row.tax)*100).toFixed(2)+'%' }}
                    </template>
                </el-table-column>
                <el-table-column label="总计" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.costAgent).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template #default="scope">
                        <el-button type="primary" @click="editService(scope.row)" icon="Edit"></el-button>
                        <el-button type="danger" @click="removeService(scope.row)" icon="Delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-form :inline="true" :model="addForm" label-position="right" label-width="72" style="margin-top:30px;">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="税前金额：">
                            <el-input v-model="addForm.cost" @input="costChange" placeholder="请输入税前金额"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="税点：">
                            <el-input v-model="addForm.tax" @input="taxChange" placeholder="请输入税点"><template #append>%</template></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="总计：">
                            <el-input type="number" v-model="addCostTotal" readonly disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="描述：" style="width:calc(100% - 32px)">
                            <el-input maxlength="10" v-model="addForm.serviceName" placeholder="请输入描述"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <el-button type="primary" @click="init">新增服务</el-button>
                <el-button type="success" @click="isEditService?editServiceSubmit():addServiceSubmit()">提交</el-button>
            </template>
        </el-dialog>
        <!-- 下载历史账单弹窗 -->
        <el-dialog width="480px" v-model="historyVisible" title="批量下载历史账单" :close-on-click-modal="false">
            <el-form label-position="top" :model="historyForm" style="padding:0 12px;">
                <el-form-item label="下载维度" v-if="curRole=='admin'||curRole=='sales'">
                    <el-radio-group v-model="historyForm.dimension" @change="onHistoryDimensionChange">
                        <el-radio value="agent">伙伴</el-radio>
                        <el-radio value="payer">Payer</el-radio>
                        <el-radio value="link">Link</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="伙伴" v-if="historyForm.dimension=='agent'&&curRole!='customer'">
                    <el-select v-model="historyForm.agent_id" clearable filterable placeholder="请选择伙伴" style="width:100%">
                        <el-option v-for="item in agentsList" :key="item.agent_id" :label="item.company+'('+item.agent_id+')'" :value="item.agent_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payer" v-if="historyForm.dimension=='payer'||(curRole=='agent'&&historyForm.dimension!='link')">
                    <el-select v-model="historyForm.payer_id" clearable filterable placeholder="请选择Payer" style="width:100%">
                        <el-option v-for="item in historyPayersList" :key="item.payer_id" :label="item.name+'('+item.payer_id+')'" :value="item.payer_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Link" v-if="historyForm.dimension=='link'">
                    <el-select v-model="historyForm.link_id" clearable filterable placeholder="请选择Link" style="width:100%"
                      :filter-method="historyLinkFilter">
                        <el-option v-for="item in historyDisplayedLinks" :key="item.link_id"
                          :label="(item.customer_name||item.name||item.link_id)+'（'+item.link_id+'）'"
                          :value="item.link_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间段">
                    <div style="display:flex;gap:8px;align-items:center;width:100%">
                        <el-date-picker v-model="historyForm.start_month" type="month" format="YYYY-MM" value-format="YYYYMM" placeholder="开始月份" style="flex:1"></el-date-picker>
                        <span>~</span>
                        <el-date-picker v-model="historyForm.end_month" type="month" format="YYYY-MM" value-format="YYYYMM" placeholder="结束月份" style="flex:1"></el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="账单类型">
                    <el-select v-model="historyForm.billType" style="width:100%">
                        <el-option v-for="item in billTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="historyVisible=false">取消</el-button>
                <el-button type="primary" :loading="historyLoading" @click="doDownloadHistory">开始下载</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {downloadBillByUrl,downloadBillDetail,getBillList,reGenerateBill,reDownloadBill,saleConfirmBill,
        agentConfirmBill,getServiceData,addServiceBill,delServiceBill,getSalesList,getAgentList,getPayerList,getLinkerList,downloadHistory} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import {ajaxGet} from '@/api/request';
    export default {
        components:{
            Pagination
        },
        name:'CurBillManage',
        data() {
            return {
                loading:false,
                loadingPage:false,
                tableHeight:500,
                tableMaxHeight: window.innerHeight - 320,
                formInline:{
                    month:'',
                    region:'',
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    agent_id:'',
                    billType:2,
                    account_type:'',
                    page: 1,
                    limit: 20,
                },
                addForm:{
                    cost:'',
                    tax:'',
                },
                addCostTotal:0,
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                payersList:[],
                payersMap: new Map(),
                salesList:[],
                agentsList:[],
                linksList:[],
                displayedLinksList:[],
                billTypeList:[
                    {name:'总代应付',value:1},
                    {name:'伙伴应付',value:2},
                    {name:'客户应付',value:3},
                ],
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curRole:localStorage.getItem('curRole'),
                curDate:'',
                selected:[],
                canConfirm:false,

                showCredit:true,
                showSavingPlan:true,
                showBundle:true,
                serviceVisible:false,
                curRow:null,
                serviceData:null,
                isEditService:false,
                confirmSelected:[],
                canCompute:false,
                canDownload:false,
                historyVisible:false,
                historyLoading:false,
                historyForm:{
                    dimension:'link',
                    agent_id:'',
                    payer_id:'',
                    link_id:'',
                    start_month:'',
                    end_month:'',
                    billType:2,
                },
                historyDisplayedLinks:[],
            }
        },

        created() {
            this.permissionData();
            
            let date = new Date();
            let endY =date.getFullYear();
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            let endD = date.getDate()<10?'0'+date.getDate():date.getDate();
            this.curDate=(new Date(endY+'-'+endM+'-'+endD).getTime())/1000;
            this.formInline.month=endY.toString()+endM.toString();
            
            if(localStorage.getItem('billManageForm')){
                const cachedForm = JSON.parse(localStorage.getItem('billManageForm'));
                if(this.curRole == 'customer'){
                    this.formInline.month = cachedForm.month || this.formInline.month;
                    this.formInline.region = cachedForm.region || '';
                    this.formInline.link_id = cachedForm.link_id || '';
                } else {
                    this.formInline = cachedForm;
                }
            }
            
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account')
            }else if(this.curRole == 'agent'){
                this.formInline.agent_id = localStorage.getItem('account');
                this.billTypeList=[
                    {name:'伙伴应付',value:2},
                    {name:'客户应付',value:3},
                ]
                this.historyForm.dimension = 'payer';
                this.historyForm.agent_id = localStorage.getItem('account');
            }else if(this.curRole == 'customer'){
                this.billTypeList=[{name:'客户应付',value:3}]
                this.formInline.billType = 3;
                this.formInline.link_id = localStorage.getItem('account');
                this.historyForm.dimension = 'link';
                this.historyForm.link_id = localStorage.getItem('account');
                this.historyForm.billType = 3;
            }
            
            this.getData();
        },
        computed: {
            filteredPayersList() {
                if (!this.formInline.agent_id) return this.payersList
                const agent = this.agentsList.find(a => a.agent_id === this.formInline.agent_id)
                if (!agent || !agent.payers) return this.payersList
                const ids = agent.payers.split(',').map(p => p.trim())
                return this.payersList.filter(p => ids.includes(p.payer_id))
            },
            historyPayersList() {
                if (this.curRole === 'agent') {
                    // 伙伴只看自己的 payer
                    const agent = this.agentsList.find(a => a.agent_id === localStorage.getItem('account'))
                    if (!agent || !agent.payers) return this.payersList
                    const ids = agent.payers.split(',').map(p => p.trim())
                    return this.payersList.filter(p => ids.includes(p.payer_id))
                }
                if (this.historyForm.agent_id) {
                    const agent = this.agentsList.find(a => a.agent_id === this.historyForm.agent_id)
                    if (!agent || !agent.payers) return this.payersList
                    const ids = agent.payers.split(',').map(p => p.trim())
                    return this.payersList.filter(p => ids.includes(p.payer_id))
                }
                return this.payersList
            }
        },
        methods:{
            //获取列表
            getData() {
                this.loadingPage = true;
                this.tableData = [];
                this.formInline.link_id = this.formInline.link_id ? String(this.formInline.link_id).trim() : '';
                
                // 添加超时保护
                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('请求超时')), 30000);
                });
                
                Promise.race([getBillList(this.formInline), timeoutPromise])
                .then(res => {
                    this.loadingPage = false;
                    if(!res || typeof res !== 'object') {
                        this.$message.error('服务器返回数据格式错误');
                        return;
                    }
                    if(res.code == 2000) {
                        const billData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
                        this.tableData = billData;
                        var num1=0,num2=0,num3=0;
                        this.tableData.forEach(el=>{
                            num1 = Number(num1) + Number(el.credit);
                            num2 = Number(num2) + Number(el.spNegation);
                            num3 = Number(num3) + Number(el.bundledDiscount);
                        })
                        this.showCredit = num1 != 0;
                        this.showSavingPlan = num2 != 0;
                        this.showBundle = num3 != 0;
                        this.pageparm.page = res.page || 1;
                        this.pageparm.limit = res.limit || 10;
                        this.pageparm.total = res.total || 0;
                    }else{
                        this.$message.error(res.msg || '获取账单列表失败');
                    }
                }).catch(error => {
                    this.loadingPage = false;
                    this.$message.error(error.message || '请求失败，请稍后重试');
                })
            },
            permissionData(){
                this.getLinksList();
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                    this.getPayersList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                    this.getPayersList();
                }else if(this.curRole == 'agent'){
                    this.getPayersList();
                }
                // customer角色不需要加载payer列表,因为界面上不显示payer下拉框
            },
            // 获取伙伴列表
            getAgentsList(){
                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('获取伙伴列表超时')), 10000);
                });
                
                Promise.race([getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}), timeoutPromise])
                .then(res=>{
                    if(res && res.code==2000){
                        this.agentsList = res.data.data || res.data || [];
                    }else{
                        this.$message.error('获取伙伴列表失败！');
                    }
                }).catch(error => {
                    this.$message.error('获取伙伴列表超时或失败');
                })
            },
            // 获取销售列表
            getSaleList(){
                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('获取销售列表超时')), 10000);
                });
                
                Promise.race([getSalesList({name:'',phone:'',page:1,limit:999999}), timeoutPromise])
                .then(res=>{
                    if(res && res.code==2000){
                        this.salesList = res.data.data || res.data || [];
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                }).catch(error => {
                    this.$message.error('获取销售列表超时或失败');
                })
            },
            // 获取payer列表
            getPayersList(){
                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('获取Payer列表超时')), 10000);
                });
                
                Promise.race([getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}), timeoutPromise])
                .then(res=>{
                    if(res && res.code==2000){
                        this.payersList = res.data.data || res.data || [];
                        this.payersMap.clear();
                        this.payersList.forEach(payer => {
                            this.payersMap.set(payer.payer_id, payer);
                        });
                    }else{
                        console.error('获取Payer列表失败:', res);
                        this.$message.warning('获取Payer列表失败，部分功能可能受限');
                    }
                }).catch(error => {
                    console.error('获取Payer列表异常:', error);
                    this.$message.warning('获取Payer列表超时，部分功能可能受限');
                })
            },
            // 获取link列表
            getLinksList(){
                getLinkerList({page:1,limit:9999}).then(res=>{
                    if(res && res.code==2000){
                        this.linksList = res.data.data || res.data || [];
                        this.displayedLinksList = this.linksList.slice(0, 50);
                    }
                }).catch(()=>{})
            },
            // link下拉框搜索
            linkFilterMethod(query){
                if(!query){
                    this.displayedLinksList = this.linksList.slice(0, 50);
                    return;
                }
                const q = query.trim();
                this.displayedLinksList = this.linksList.filter(item => {
                    return String(item.link_id).includes(q) || 
                           (item.customer_name && item.customer_name.includes(q)) ||
                           (item.name && item.name.includes(q));
                }).slice(0, 50);
            },
            // === 下载历史账单 ===
            onHistoryDimensionChange(){
                this.historyForm.agent_id = '';
                this.historyForm.payer_id = '';
                this.historyForm.link_id = '';
            },
            historyLinkFilter(query){
                if(!query){
                    this.historyDisplayedLinks = this.linksList.slice(0, 50);
                    return;
                }
                const q = query.trim();
                this.historyDisplayedLinks = this.linksList.filter(item => {
                    return String(item.link_id).includes(q) ||
                           (item.customer_name && item.customer_name.includes(q)) ||
                           (item.name && item.name.includes(q));
                }).slice(0, 50);
            },
            doDownloadHistory(){
                const f = this.historyForm;
                if(!f.start_month || !f.end_month){
                    this.$message.warning('请选择时间段');
                    return;
                }
                if(parseInt(f.start_month) > parseInt(f.end_month)){
                    this.$message.warning('开始月份不能大于结束月份');
                    return;
                }
                // 校验维度对应的必填项
                if(this.curRole=='admin'||this.curRole=='sales'){
                    if(f.dimension=='agent' && !f.agent_id){
                        this.$message.warning('请选择伙伴'); return;
                    }
                    if(f.dimension=='payer' && !f.payer_id){
                        this.$message.warning('请选择Payer'); return;
                    }
                    if(f.dimension=='link' && !f.link_id){
                        this.$message.warning('请选择Link'); return;
                    }
                }
                if(this.curRole=='agent' && f.dimension=='link' && !f.link_id){
                    this.$message.warning('请选择Link'); return;
                }
                this.historyLoading = true;
                downloadHistory({
                    dimension: f.dimension,
                    agent_id: f.agent_id,
                    payer_id: f.payer_id,
                    link_id: f.link_id,
                    start_month: f.start_month,
                    end_month: f.end_month,
                    billType: f.billType,
                }).then(res=>{
                    this.historyLoading = false;
                    if(res.code==2000 && res.data){
                        this.historyVisible = false;
                        window.open(res.data);
                    }else{
                        this.$message.error(res.msg || '下载失败');
                    }
                }).catch(err=>{
                    this.historyLoading = false;
                    this.$message.error(err.message || '请求失败');
                });
            },
            // 通过文件流下载
            downloadTheBillByBlob(type,linkId){
                if(linkId){//点击linkId下载单个
                    downloadBillByBlob({link_id:linkId,month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        if(res.size<=73){
                            this.$message.error('无账单文件，请联系管理员！')
                        }else{
                            const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                            const a = document.createElement('a')
                            document.body.appendChild(a)
                            a.href = url
                            a.download = '单个账单.zip'
                            a.click()
                            window.URL.revokeObjectURL(url)
                        }
                    })
                }else{
                    if(type==1){//下载选中账单
                        var arr=[];
                        this.selected.forEach(el=>{
                            arr.push(el.linkId)
                        })
                        downloadBillByBlob({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                            if(res.size<=73){
                                this.$message.error('无账单文件，请联系管理员！')
                            }else{
                                const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                                const a = document.createElement('a')
                                document.body.appendChild(a)
                                a.href = url
                                a.download = '单个账单.zip'
                                a.click()
                                window.URL.revokeObjectURL(url)
                            }
                        })
                    }else{//下载全部账单
                        downloadBillByBlob(this.formInline).then(res=>{
                            if(res.size<=73){
                                this.$message.error('无账单文件，请联系管理员！')
                            }else{
                                const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                                const a = document.createElement('a')
                                document.body.appendChild(a)
                                a.href = url
                                a.download = '单个账单.zip'
                                a.click()
                                window.URL.revokeObjectURL(url)
                            }
                        })
                    }
                }
            },
            // 通过地址下载
            downloadTheBillByUrl(type,linkId){
                this.loading = true;
                if(linkId){//点击linkId下载单个
                    downloadBillByUrl({link_id:linkId,month:this.formInline.month,billType:this.formInline.billType,use_old_version:'true'}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{
                    if(type==1){//下载选中账单
                        var arr=[];
                        this.selected.forEach(el=>{
                            arr.push(el.linkId)
                        })
                        downloadBillByUrl({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType,use_old_version:'true'}).then(res=>{
                            this.loading = false;
                            if(res.code==2000){
                                if(res.data){
                                    this.downloadFile(res.data)
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }else{//下载全部账单
                        downloadBillByUrl({...this.formInline,use_old_version:'true'}).then(res=>{
                            this.loading = false;
                            if(res.code==2000){
                                if(res.data){
                                    this.downloadFile(res.data)
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }
                }
            },
            // 下载
            downloadFile(url){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.click()
                setTimeout(()=>{
                    a.remove()
                },1000)
            },
            isRowSelectable(row,index){
                // if(row.locked!=2&&this.computeDate()){
                //     return true;
                // }else{
                //     return false;
                // }
                if(this.curRole=='agent'){
                    return row.locked==1
                }else{
                    return row.locked==0 && this.computeDate();
                }

            },
            // 复选框勾选
            selectionChange(val){
                this.selected=val;
                if(this.selected.length>0){
                    if(this.curRole=='agent'){
                        this.confirmSelected = val.filter(item=>{
                            return item.locked == 1;
                        })
                    }else{
                        this.confirmSelected = val.filter(item=>{
                            return (item.locked==0||item.locked==3) && this.computeDate();
                        })
                    }
                    if(this.confirmSelected.length>0){
                        this.canConfirm = true;
                    }else{
                        this.canConfirm = false;
                    }
                }else{
                    this.canConfirm = false;
                }
            },
            // 重新计算账单
            reCompute(payerId,linkId){
                this.canCompute = true;
                reGenerateBill({month:this.formInline.month,payerId:payerId,linkId:linkId}).then(res=>{
                    if(res.code ==2000){
                        this.$message.success(res.msg);
                        this.canCompute = false;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 重新下载原始账单
            reDownload(payerId,linkId){
                this.canDownload = true;
                reDownloadBill({month:this.formInline.month,payerId:payerId,linkId:linkId}).then(res=>{
                    if(res.code ==2000){
                        this.$message.success(res.msg);
                        this.canDownload = false;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            downloadRightBill(type){
                this.loading = true;
                if(type==1){//下载选中账单
                    var arr=[];
                    this.selected.forEach(el=>{
                        arr.push(el.linkId)
                    })
                    downloadBillDetail({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType,use_old_version:'true'}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{//下载全部账单
                    downloadBillDetail({...this.formInline,use_old_version:'true'}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            addService(obj){
                this.curRow = JSON.parse(JSON.stringify(obj));
                this.getSData();
                setTimeout(()=>{
                    this.serviceVisible = true;
                    this.isEditService = false;
                },200)
            },
            getSData(linkId){
                getServiceData({linkId:this.curRow.linkId,month:this.formInline.month}).then(res=>{
                    if(res.code==2000){
                        this.serviceData = res.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            init(){
                this.addForm={
                    cost:'',
                    tax:'',
                    serviceName:'',
                }
                this.addCostTotal = 0;
                this.isEditService =false;
            },
            costChange(val){
                this.addForm.cost = val.replace(/[^\d.]/g,'');
                if(this.addForm.tax){
                    this.addCostTotal =((Number(this.addForm.cost) * (Number(this.addForm.tax)+100))/100).toFixed(2);
                }else{
                    this.addCostTotal = this.addForm.cost;
                }
            },
            taxChange(val){
                this.addForm.tax = val.replace(/[^\d.]/g,'');
                if(this.addForm.cost){
                    this.addCostTotal =((Number(this.addForm.cost) * (Number(this.addForm.tax)+100))/100).toFixed(2);
                }else{
                    this.addCostTotal = 0;
                }
            },
            addServiceSubmit(){
                var obj={
                    linkId:this.curRow.linkId,
                    payerId:this.curRow.payerId,
                    month:this.formInline.month,
                    serviceCode:this.addForm.serviceName,
                    entity:this.curRow.entity
                }
                this.addForm.tax = this.addForm.tax / 100;
                addServiceBill({...obj,...this.addForm}).then(res=>{
                    if(res.code==2000){
                        this.$message.success('添加服务成功！');
                        this.init();
                        this.getSData();
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            editService(obj){
                this.addForm = JSON.parse(JSON.stringify(obj));
                this.addForm.tax = this.addForm.tax*100;
                this.isEditService = true;
            },
            removeService(obj){
                this.$confirm('确定删除该服务吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    delServiceBill({id:obj.id,linkId:obj.linkId}).then(res=>{
                        if(res.code==2000){
                            this.getSData();
                            this.$message.success('删除成功！')
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                })
            },
            editServiceSubmit(){
                this.addForm.tax = this.addForm.tax / 100;
                addServiceBill(this.addForm).then(res=>{
                    if(res.code==2000){
                        this.$message.success('修改服务成功！');
                        this.init();
                        this.getSData();
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },

            confirmBill(){
                var txt="账单一经确认，将会锁定账单且无法修改，是否继续？";
                if(this.curRole == 'agent'){
                    txt = '橘色标记的账单将确认，'+txt;
                }else if(this.curRole=='admin'||this.curRole=='sales'){
                    txt = '黄色标记的账单将确认，'+txt;
                }
                this.$confirm(txt,'提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    var arr=[];
                    this.confirmSelected.forEach(el=>{
                        arr.push(el.id)
                    })
                    if(this.curRole=='agent'){//伙伴确认账单
                        // result参数，2是确认账单，3是拒绝账单
                        agentConfirmBill({id:arr.join(','),result:2}).then(res=>{
                            if(res.code==2000){
                                this.$message.success('账单已确认成功！');
                                this.getData()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }else{//销售或admin确认账单
                        saleConfirmBill({id:arr.join(',')}).then(res=>{
                            if(res.code==2000){
                                this.$message.success('账单已确认成功，请通知伙伴确认账单！');
                                this.getData()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }
                })
            },
            refuseBill(id){
                this.$confirm('拒绝该账单后，请及时联系销售人员，是否继续？','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    agentConfirmBill({id:id,result:3}).then(res=>{
                        if(res.code==2000){
                            this.$message.success('账单已拒绝，请通知销售查看账单！');
                            this.getData()
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                })
            },
            onPayerChange(payerId) {
                // When payer changes, auto-set the corresponding agent
                if (payerId) {
                    const agent = this.agentsList.find(a => a.payers && a.payers.split(',').map(p=>p.trim()).includes(payerId))
                    if (agent) {
                        this.formInline.agent_id = agent.agent_id
                    }
                }
                this.formInline.link_id = ''
                this.search()
            },
            onAgentChange(agentId) {
                // When agent changes, clear payer and link selections
                this.formInline.payer_id = ''
                this.formInline.link_id = ''
                this.search()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
                localStorage.setItem('billManageForm',JSON.stringify(this.formInline));
            },
            reset() {
                this.formInline = {
                    month:'',
                    region:'',
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    agent:'',
                    billType:2,
                    page: 1,
                    limit: 20,
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            //计算当前日期和筛选日期，如果当前月份-1=筛选月份，并且当前日期大于等于10号，则该月份账单可确认，同时要根据lock来确定
            //lock=0 ：账单初始状态，可以根据上一条来判断，满足则显示黄色，不满足则显示灰色
            //lock=1 ：销售已确认状态，此时显示橘色
            //lock=2 ：代理商已确认，此时显示绿色，此时该link对应的返点不可调整，该link对应的账单，复选框无法选中标绿的这条记录
            // curDate - 1 == this.formInline.month.toString().substring(4,6)
            computeDate(){
                let date = new Date();
                //获取当前年份的后一年
                let endY =date.getFullYear();
                //获取当前月
                let endM = date.getMonth();
                let endD = date.getDate();
                let year='',month='';
                if(this.formInline.year){
                    year = Number(this.formInline.year.toString().substring(0,4));
                }
                if(this.formInline.month){
                    month = Number(this.formInline.month.toString().substring(4,6));
                }
                if(endY==year&&endM==month&&endD>=10){
                    return true
                }else if(endY==year&&endM>month){
                    return true;
                }else if(endY>year){
                    return true;
                }else{
                    return false;
                }
            },
            // 状态圆点样式（原型 w-2 h-2 rounded-full）
            getStatusClass(locked) {
                if (locked == 2) return 'dot-green';
                if (locked == 1) return 'dot-orange';
                if (locked == 3) return 'dot-red';
                return this.computeDate() ? 'dot-yellow' : 'dot-gray';
            },
            getStatusText(locked) {
                if (locked == 2) return '账单已确认';
                if (locked == 1) return '伙伴待确认';
                if (locked == 3) return '伙伴已拒绝';
                return this.computeDate() ? '销售待确认' : '账单未生成';
            },

            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            listenResize() {
                this.getTheTableHeight()
            },
            getTheTableHeight(){
                this.$nextTick(() => {
                    const tableCard = this.$refs.tableCard
                    if (tableCard) {
                        const rect = tableCard.getBoundingClientRect()
                        // 分页高度：padding(12*2) + 内容(32) + border-top(1) = 57
                        const paginationH = 57
                        // 底部留白：tab-content margin-bottom(20) + 安全余量(2)
                        const bottomMargin = 22
                        this.tableMaxHeight = window.innerHeight - rect.top - paginationH - bottomMargin
                    } else {
                        this.tableMaxHeight = window.innerHeight - 400
                    }
                    if (this.tableMaxHeight < 200) this.tableMaxHeight = 200
                    this.tableHeight = this.tableMaxHeight
                })
            },
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
              // 延迟再算一次，确保父容器 tab 导航已渲染完毕
              setTimeout(() => { this.getTheTableHeight() }, 300)
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss">
.billManage {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* ===== 筛选栏（对齐原型 BillManagementPage.tsx Filter Bar） ===== */
  .cur-filter-bar {
    flex-shrink: 0;
    background: #FFFFFF;
    border-radius: 12px;
    border: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    padding: 20px 20px 16px;
    margin-bottom: 16px;
  }

  .cur-filter-row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 12px;
  }

  .cur-filter-item {
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
      font-size: 11px;
      color: #52525b;
      font-weight: 400;
      line-height: 1;
      white-space: nowrap;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    /* 非 scoped 样式不需要 :deep()，直接用普通选择器 */
    .el-input__wrapper,
    .el-select .el-input__wrapper,
    .el-date-editor .el-input__wrapper {
      border-radius: 8px !important;
      height: 34px !important;
      box-shadow: none !important;
      background: #f4f4f5 !important;
      border: none !important;
      padding: 0 12px !important;
    }

    .el-input__wrapper:hover,
    .el-select .el-input__wrapper:hover,
    .el-date-editor .el-input__wrapper:hover {
      background: #ebebec !important;
      box-shadow: none !important;
    }

    .el-input__wrapper.is-focus,
    .el-select .el-input__wrapper.is-focus {
      box-shadow: 0 0 0 1px #2563eb inset !important;
      background: #FFFFFF !important;
    }

    .el-input__suffix,
    .el-select__suffix,
    .el-input__prefix {
      background: transparent !important;
    }

    .el-date-editor.el-input {
      height: 34px !important;
      line-height: 34px !important;
      --el-date-editor-width: 140px;
    }
    .el-date-editor .el-input__prefix {
      height: 34px !important;
      line-height: 34px !important;
    }
    /* el-date-editor 外层容器高度对齐 */
    .el-date-editor {
      height: 34px !important;
      display: inline-flex !important;
      align-items: center !important;
    }
    /* el-date-editor 内部 input 也要 34px */
    .el-date-editor .el-input {
      height: 34px !important;
    }
    .el-date-editor .el-input__wrapper {
      height: 34px !important;
      min-height: 34px !important;
      max-height: 34px !important;
    }
    /* el-select 外层容器高度对齐 */
    .el-select {
      height: 34px !important;
    }
    .el-select .el-input {
      height: 34px !important;
    }

    .el-input__inner {
      font-size: 13px !important;
      color: #1b1b1f !important;
      font-weight: 400 !important;
      height: 34px !important;
      line-height: 34px !important;
    }

    .el-select__placeholder,
    .el-select__placeholder.is-transparent,
    .el-input .el-input__inner::placeholder {
      font-size: 13px !important;
      color: #1b1b1f !important;
      font-weight: 400 !important;
      -webkit-text-fill-color: #1b1b1f !important;
      opacity: 1 !important;
    }

    /* el-select 选中值的文字 */
    .el-select__selected-item,
    .el-select__placeholder:not(.is-transparent) {
      font-size: 13px !important;
      color: #1b1b1f !important;
      font-weight: 400 !important;
    }

    /* CSS 变量覆盖 placeholder 颜色 */
    .el-select {
      --el-text-color-placeholder: #1b1b1f;
      --el-select-input-color: #1b1b1f;
    }
    .el-input {
      --el-text-color-placeholder: #1b1b1f;
    }
    .el-date-editor {
      --el-text-color-placeholder: #1b1b1f;
    }
  }

  .cur-filter-actions {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    margin-left: auto;
    flex-shrink: 0;

    .btn-search {
      background: #1a1a2e !important;
      border-color: #1a1a2e !important;
      color: #FFFFFF !important;
      border-radius: 8px !important;
      height: 34px !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif !important;
      padding: 0 20px !important;
      letter-spacing: normal !important;
      &:hover { opacity: 0.9; }
    }

    .btn-reset {
      background: #FFFFFF !important;
      border: 1px solid #e5e7eb !important;
      border-color: #e5e7eb !important;
      color: #1a1a2e !important;
      border-radius: 8px !important;
      height: 34px !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif !important;
      padding: 0 20px !important;
      letter-spacing: normal !important;
      &:hover { background: #f4f4f5 !important; }
    }
  }

  .cur-action-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 4px;
    padding-top: 4px;

    .action-link {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;
      color: #2563eb;
      cursor: pointer;
      font-weight: 400;
      transition: all 0.15s;
      &:hover { text-decoration: underline; color: #1d4ed8; }
      &.warning { color: #FF9500; &:hover { color: #cc7700; } }
      &.disabled { color: #a1a1aa; cursor: not-allowed; &:hover { text-decoration: none; } }
      .el-icon { font-size: 14px; }
    }
  }

  /* ===== 表格卡片（原型 Data Table Card） ===== */
  .table-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 12px;
    border: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  }

  .table {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .el-table {
      // 表头 — 深色，uppercase, 12px
      .el-table__header-wrapper {
        .el-table__header th {
          background: #fafafa !important;
          color: #1a1a2e !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          border-bottom: 1px solid #e5e7eb !important;
          padding: 10px 0 !important;
        }
        .el-table__header th .cell {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #1a1a2e !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          padding: 0 12px !important;
        }
      }

      // 行 — 原型：13px
      .el-table__body-wrapper {
        .el-table__row td {
          font-size: 13px !important;
          color: #1b1b1f !important;
          font-weight: 400;
          border-bottom: 1px solid rgba(229,231,235,0.5) !important;
          padding: 10px 0 !important;
        }
        .el-table__row td .cell {
          font-variant-numeric: tabular-nums;
          padding: 0 12px !important;
        }
        .el-table__row:hover td {
          background: rgba(244,244,245,0.3) !important;
        }
      }

      // stripe 行
      .el-table__row--striped td {
        background: rgba(244,244,245,0.4) !important;
      }
    }
  }

  /* ===== 分页（原型: 黑底白字当前页） ===== */
  .pagination-wrapper {
    flex-shrink: 0;
    padding: 12px 20px;
    background: #fff;
    border-top: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .pagination-total {
      font-size: 13px;
      color: #71717a;
    }
  }

  /* ===== 状态圆点（原型 w-2 h-2 rounded-full） ===== */
  .status-dot-cell {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    cursor: pointer;

    &.dot-green  { background: #22c55e; }
    &.dot-yellow { background: #eab308; }
    &.dot-orange { background: #f97316; }
    &.dot-red    { background: #ef4444; }
    &.dot-gray   { background: #9ca3af; }
  }

  /* ===== LinkerId 列 ===== */
  .linker-id-text {
    font-size: 13px;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    color: #1b1b1f !important;
  }
  .linker-id-link {
    font-size: 13px;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    color: #1b1b1f !important;
    cursor: pointer;
    &:hover { color: #2563eb !important; text-decoration: underline; }
  }

  /* ===== Discount 负值红色（原型 text-red-500） ===== */
  .text-red { color: #ef4444; }

  /* ===== 排序箭头：激活时蓝色 ===== */
  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #0073bb;
  }
  .el-table .descending .sort-caret.descending {
    border-top-color: #0073bb;
  }

  /* ===== 操作列图标（原型 w-3.5 h-3.5 text-muted-foreground） ===== */
  .op-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  .op-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s;
    color: #71717a;

    .el-icon { font-size: 14px; }

    &:hover { background: #f4f4f5; color: #18181b; }
    &:disabled { color: #d1d5db; cursor: not-allowed; &:hover { background: transparent; } }
    &.danger:hover { background: #fef2f2; color: #ef4444; }
  }
}

.el-popper.is-customized {
  background: #1D1D1F;
  color: #fff;
  font-size: 12px;
}
.el-popper.is-customized .el-popper__arrow::before {
  background: #1D1D1F;
}
</style>
